"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _InfoInputsValue = _interopRequireDefault(require("./InfoInputsValue"));
var _InfoOutputsValue = _interopRequireDefault(require("./InfoOutputsValue"));
var _InfoReferencesInner = _interopRequireDefault(require("./InfoReferencesInner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * The Info model module.
 * @module model/Info
 * @version 1.0.0
 */
var Info = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Info</code>.
   * @alias module:model/Info
   */
  function Info() {
    _classCallCheck(this, Info);
    Info.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  _createClass(Info, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Info</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Info} obj Optional instance to populate.
     * @return {module:model/Info} The populated <code>Info</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Info();
        if (data.hasOwnProperty('script')) {
          obj['script'] = _ApiClient.default.convertToType(data['script'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('external_link')) {
          obj['external_link'] = _ApiClient.default.convertToType(data['external_link'], 'String');
        }
        if (data.hasOwnProperty('timeout')) {
          obj['timeout'] = _ApiClient.default.convertToType(data['timeout'], 'Number');
        }
        if (data.hasOwnProperty('inputs')) {
          obj['inputs'] = _ApiClient.default.convertToType(data['inputs'], {
            'String': _InfoInputsValue.default
          });
        }
        if (data.hasOwnProperty('outputs')) {
          obj['outputs'] = _ApiClient.default.convertToType(data['outputs'], {
            'String': _InfoOutputsValue.default
          });
        }
        if (data.hasOwnProperty('references')) {
          obj['references'] = _ApiClient.default.convertToType(data['references'], [_InfoReferencesInner.default]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Info</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Info</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['script'] && !(typeof data['script'] === 'string' || data['script'] instanceof String)) {
        throw new Error("Expected the field `script` to be a primitive type in the JSON string but got " + data['script']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['external_link'] && !(typeof data['external_link'] === 'string' || data['external_link'] instanceof String)) {
        throw new Error("Expected the field `external_link` to be a primitive type in the JSON string but got " + data['external_link']);
      }
      if (data['references']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['references'])) {
          throw new Error("Expected the field `references` to be an array in the JSON data but got " + data['references']);
        }
        // validate the optional field `references` (array)
        var _iterator = _createForOfIteratorHelper(data['references']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _InfoReferencesInner.default.validateJsonObject(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      return true;
    }
  }]);
  return Info;
}();
/**
 * @member {String} script
 */
Info.prototype['script'] = undefined;

/**
 * @member {String} description
 */
Info.prototype['description'] = undefined;

/**
 * @member {String} external_link
 */
Info.prototype['external_link'] = undefined;

/**
 * @member {Number} timeout
 */
Info.prototype['timeout'] = undefined;

/**
 * @member {Object.<String, module:model/InfoInputsValue>} inputs
 */
Info.prototype['inputs'] = undefined;

/**
 * @member {Object.<String, module:model/InfoOutputsValue>} outputs
 */
Info.prototype['outputs'] = undefined;

/**
 * @member {Array.<module:model/InfoReferencesInner>} references
 */
Info.prototype['references'] = undefined;
var _default = Info;
exports.default = _default;